import { render, staticRenderFns } from "./InstructionsForUse.vue?vue&type=template&id=6e22422f&scoped=true&"
import script from "./InstructionsForUse.vue?vue&type=script&lang=js&"
export * from "./InstructionsForUse.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsForUse.vue?vue&type=style&index=0&id=6e22422f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22422f",
  null
  
)

export default component.exports